import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function SsoStatsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SsoStats', {
		url: '/admin/sso/sps/:id/stats',
		controllerAs: 'vm',
		controller: SsoStatsCtrl,
		templateUrl: '/ng/hub/Sso/Stats/SsoStatsCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'SSO Statistics',
			stats: ApiResourcify.endpoint('/sso/sps/:id/stats'),
		},
	});
}

export class SsoStatsCtrl {
	constructor(stats) {
		'ngInject';
		this.stats = stats;
	}

	useAsConditions(stat) {
		// $addConditions is a function sent from modal creator
		this.$addConditions(stat, Object.keys(this.stats[stat]));
		this.$resolve();
	}
}
